__turbopack_context__.v({
  "section": "CardView-module-scss-module__oHsK9G__section",
});
